import React, { useContext } from "react";
import { Button } from "antd";
import style from "./index.module.scss";
import { isTrue } from "service/service";
import Config from "config";
import { CourseContext } from "../../../../Store";
import { HaveWeekTime } from "../../../../../../service/course";
import Storage from "utils/Storage";
import { stopJump } from "../../../../../../utils/common";
import NavItem from "./Components/NavItem";
import { useHistory } from "react-router-dom";

export default function NavBar() {
    const { course } = useContext(CourseContext);
    const { isCloud, isOpen, platformType, courseNo, courseSeq } = course;

    function isHasThirdParty() {
        return isTrue(isOpen) && platformType !== "1";
    }

    function gotoLive(url: string, channelId: string) {
        const batchNo = Storage.get("batch") || Config.DefaultBatch;
        return stopJump(
            `${url}?courseNo=${courseNo}&courseSeq=${courseSeq}&batchNo=${batchNo}&customerCode=${Config.CustomCode}&channelId=${channelId}`,
            null
        );
    }

    const history = useHistory();

    return (
        <div className={style.root}>
            <div className={style.links}>
                <NavItem src="resource" text="课件" />
                {course.weekTimeId !== HaveWeekTime.no && (
                    <>
                        <NavItem src="signin" text="签到" />
                        <NavItem src="rollcall" text="选人" />
                        <NavItem src="vote" text="投票" />
                        <NavItem src="exercise" text="练习" />
                        <NavItem src="homework" text="作业" />
                        <NavItem src="group" text="小组" />
                        {isTrue(isCloud) && (
                            <NavItem src="experiment" text="实验" />
                        )}
                        <NavItem src="question" text="问卷" />
                        <NavItem src="meeting" text="会议活动" />
                        <NavItem src="report" text="课堂报告" />
                        <NavItem src="discuss" text="主题讨论" />
                    </>
                )}
            </div>

            {course.weekTimeId !== HaveWeekTime.no && (
                <div className={style.setButton}>
                    {!isHasThirdParty() && (
                        <Button
                            type="primary"
                            className={style.button}
                            onClick={() =>
                                gotoLive(Config.LiveUrl, course.channelId)
                            }>
                            网页直播
                        </Button>
                    )}
                    {!isHasThirdParty() && (
                        <Button
                            type="primary"
                            className={style.button}
                            onClick={() =>
                                gotoLive(Config.LiveUrlClient, course.channelId)
                            }>
                            客户端直播
                        </Button>
                    )}
                    <Button
                        type="primary"
                        className={style.button}
                        onClick={() =>
                            history.push(
                                `/course/projection/${course.weekTimeId}`
                            )
                        }>
                        投屏
                    </Button>
                </div>
            )}
        </div>
    );
}
